/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerGCSEquipments.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for GCS Equipments
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, April 01, 2019 - 08:21:08 AM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      04/01/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    GCSEQUIPMENT_LIST_CONTAINER_LOADED,
    GCSEQUIPMENT_LIST_CONTAINER_UNLOADED,
    GCSEQUIPMENT_LIST_TABLE_LOADED,
    GCSEQUIPMENT_LIST_TABLE_UNLOADED,

    GCSEQUIPMENT_SET_GROUP_SELECT,
    GCSEQUIPMENT_LIST_CHANGE_GROUP,
    GCSEQUIPMENT_SELECT_ROW,
    GCSEQUIPMENT_ADD,
    GCSEQUIPMENT_EDIT,
    GCSEQUIPMENT_DELETE,
    GCSEQUIPMENT_OPEN_WARNING,
    GCSEQUIPMENT_CLOSE_WARNING,
    GCSEQUIPMENT_DELETE_DISABLE,

    GCSEQUIPMENT_EDIT_CONTAINER_LOADED,
    GCSEQUIPMENT_EDIT_CONTAINER_UNLOADED,
    GCSEQUIPMENT_EDIT_FORM_LOADED,
    GCSEQUIPMENT_EDIT_FORM_UNLOADED,
    GCSEQUIPMENT_EDIT_DATA_LOAD,
    GCSEQUIPMENT_EDIT_CONTAINER_SUBMIT,
    GCSEQUIPMENT_EDIT_CONTAINER_CANCEL,
    GCSEQUIPMENT_SET_VALUE
} from '../constants/actionTypeGCSEquipments';

const defaultState = {
    refreshList: false,
    danger: false,
    equipmentid: 0,
    rigid: 0,
    sectionid: 0,
    parentid: 0,
    equipmentsapid: '',
    name: '',
    description: '',
    workcenter: '',
    photoid: 0,
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case GCSEQUIPMENT_LIST_CONTAINER_LOADED:
        case GCSEQUIPMENT_LIST_CHANGE_GROUP:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                gcsequipments: action.payload[0] ? action.payload[0].records : null,
                itempath: action.payload[3] ? action.payload[3].records : []
            }
        case GCSEQUIPMENT_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case GCSEQUIPMENT_SET_GROUP_SELECT:
            return {
                ...state,
                [action.key]: action.payload ? action.payload : []
            }
        case GCSEQUIPMENT_SELECT_ROW:
            return {
                ...state,
                equipmentid: action.id
            }
        case GCSEQUIPMENT_ADD:
            return {
                ...state
            }
        case GCSEQUIPMENT_EDIT:
            return {
                ...state,
                equipmentid: action.id
            }
        case GCSEQUIPMENT_DELETE:
            return {
                ...state,
                equipmentid: null
            }
        case GCSEQUIPMENT_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case GCSEQUIPMENT_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case GCSEQUIPMENT_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case GCSEQUIPMENT_EDIT_CONTAINER_LOADED:
        case GCSEQUIPMENT_EDIT_DATA_LOAD:
            return {
                ...state,
                equipmentid: action.payload[0] ? action.payload[0].equipmentid : 0,
                rigid: action.payload[0] ? action.payload[0].rigid : 0,
                sectionid: action.payload[0] ? action.payload[0].sectionid : 0,
                parentid: action.payload[0] ? action.payload[0].parentid : 0,
                equipmentsapid: action.payload[0] ? action.payload[0].equipmentsapid : '',
                name: action.payload[0] ? action.payload[0].name : '',
                description: action.payload[0] ? action.payload[0].description : '',
                workcenter: action.payload[0] ? action.payload[0].workcenter : '',
                photoid: action.payload[0] ? action.payload[0].photoid : 0,
                photoid_display: action.payload[0] ? action.payload[0].photoid_display : '',
                photourl: action.payload[0] ? action.payload[0].photourl : '',
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : '',
                locationpath: action.payload[1] ? action.payload[1].records : [],
                equipmentpath: action.payload[2] ? action.payload[2].records : []
            }
        case GCSEQUIPMENT_SET_VALUE:
            return {
                ...state,
                [action.key]: action.value ? action.value : null
            }
        case GCSEQUIPMENT_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case GCSEQUIPMENT_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case GCSEQUIPMENT_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case GCSEQUIPMENT_LIST_CONTAINER_UNLOADED:
        case GCSEQUIPMENT_LIST_TABLE_UNLOADED:
        case GCSEQUIPMENT_EDIT_CONTAINER_UNLOADED:
        case GCSEQUIPMENT_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerGCSEquipments.js